import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import intl from 'react-intl-universal';
import Axios from '../../config/Axios';
import Page from '../default-v2/Page';
import Breadcrumb from '../../components/Breadcrumbs';
import userImg from '../../assets/img/users.svg';
import {
  ResponsibilityMigrationPageHeader,
  SelectResponsibleModal,
} from '../operational-panel/MigrateResponsibilityOperational';

const MigrateResponsibilityMonitoring = () => {
  const { nId } = useParams();
  const nUserId = Number(nId);
  const [cSearch, setSearch] = useState('');
  const [aUsers, setUsers] = useState([]);
  const [aDevices, setDevices] = useState([]);
  const [aSelectedDevices, setSelectedDevices] = useState([]);
  const [bMigrateModal, setMigrateModal] = useState(false);
  const [bMigrateAll, setMigrateAll] = useState(false);
  const [bLoading, setLoading] = useState(true);

  const loadDevices = useCallback(async () => {
    setLoading(true);
    try {
      let nPage = 1;
      let bHasNextPage = true;
      const aAllDevices = [];
      while (bHasNextPage) {
        const { data } = await Axios.get('/monitoring/responsibilities/' + nUserId, {
          params: { search: cSearch, page: nPage },
        });
        aAllDevices.push(...(data.responsibilities || []));
        bHasNextPage = !!data.hasNextPage;
        nPage += 1;
      }
      setDevices(aAllDevices);
      setSelectedDevices([]);
    } finally {
      setLoading(false);
    }
  }, [nUserId, cSearch]);

  useEffect(() => {
    if (!nUserId) return;
    loadDevices();
    Axios.get('/user/all').then(({ data }) => {
      setUsers((data.aUsers || [])
        .filter((oUser) => Number(oUser.user_nid) !== nUserId)
        .map((oUser) => ({ value: oUser.user_nid, label: oUser.user_cname })));
    });
  }, [loadDevices, nUserId]);

  const migrate = async (nNewUser, cPassword, bAll) => {
    await Axios.post('/monitoring/responsibilities/' + nUserId + '/migrate', {
      nNewUser,
      cPassword,
      bMigrateAll: bAll,
      aDeviceIds: bAll ? [] : aSelectedDevices,
    });
    setMigrateModal(false);
    loadDevices();
  };

  const toggleDevice = (nDeviceId, bChecked) => {
    setSelectedDevices((aCurrent) => bChecked
      ? [...new Set([...aCurrent, nDeviceId])]
      : aCurrent.filter((nIdItem) => nIdItem !== nDeviceId));
  };

  const openMigration = (bAll) => {
    setMigrateAll(bAll);
    setMigrateModal(true);
  };

  return (
    <Page
      loading={0}
      className="v2-document"
      rcmpBreadcrumb={<Breadcrumb aPages={[
        { cName: 'user', cLink: '/user' },
        { cName: 'PermissionGroup.monitoring', cLink: '/monitoring' },
        { cName: 'User.migrate_responsibilities' },
      ]} />}
      cTitle={intl.get('User.migrate_responsibilities')}
      cImage={userImg}
      rcmpCardHeader={<ResponsibilityMigrationPageHeader onSearchChange={setSearch} />}
      cCurrentSideMenuOption={intl.get('PermissionGroup.monitoring')}
    >
      <div className="v2-document" style={{ height: '64vh', overflowY: 'auto' }}>
        <div className="filterList noselect migrate-list">
          <span className="alt-checkbox-v2">
            <input
              type="checkbox"
              checked={aDevices.length > 0 && aSelectedDevices.length === aDevices.length}
              onChange={(oEvent) => setSelectedDevices(
                oEvent.target.checked ? aDevices.map((oDevice) => oDevice.nId) : []
              )}
            />
          </span>
          <span className="filterByName-v2">{intl.get('name')}</span>
          <span className="filterByPublish">{intl.get('LinkDocument.tipo')}</span>
          <span className="filterByDue">Unidade</span>
          <span className="filterByResponsible-v2">{intl.get('Dashboard.place')}</span>
          <span className="filterByEnvelope">Função</span>
        </div>
        {bLoading && <div className="centered-text">{intl.get('carregando')}</div>}
        {!bLoading && aDevices.map((oDevice) => (
          <div className="filterList noselect migrate-list" key={oDevice.nId}>
            <span className="alt-checkbox-v2">
              <input
                type="checkbox"
                checked={aSelectedDevices.includes(oDevice.nId)}
                onChange={(oEvent) => toggleDevice(oDevice.nId, oEvent.target.checked)}
              />
            </span>
            <span className="filterByName-v2" title={oDevice.cName}>{oDevice.cName}</span>
            <span className="filterByPublish">{[oDevice.cType, oDevice.cMetricType, oDevice.cProvider].filter(Boolean).join(' / ') || '-'}</span>
            <span className="filterByDue">{oDevice.cUnit || '-'}</span>
            <span className="filterByResponsible-v2">{[oDevice.cLocation, oDevice.cRoom].filter(Boolean).join(' / ') || '-'}</span>
            <span className="filterByEnvelope">{oDevice.aRoles.map((cRole) => (
              cRole === 'entry' ? intl.get('User.monitoring_launcher') : intl.get('responsible')
            )).join(', ')}</span>
          </div>
        ))}
      </div>
      <div className="button-stack">
        <Button type="button" className="btn break-line-btn" onClick={() => openMigration(true)}>
          {intl.get('FolderIndex.migrate')}<br />{intl.get('User.all')}
        </Button>
        <Button
          type="button"
          className="btn break-line-btn"
          disabled={aSelectedDevices.length === 0}
          onClick={() => openMigration(false)}
        >
          {intl.get('FolderIndex.migrate')}<br />{intl.get('FolderIndex.selecteds')}
        </Button>
      </div>
      {bMigrateModal && (
        <SelectResponsibleModal
          onClose={() => setMigrateModal(false)}
          aUsers={aUsers}
          onSubmit={migrate}
          bMigrateAll={bMigrateAll}
        />
      )}
    </Page>
  );
};

export default MigrateResponsibilityMonitoring;
